import React, { useState } from "react";
import loanOrigination from "./../Assets/loan_origination.jpeg";
import Underwriting from "./../Assets/underwriting.jpeg";
import creditRisManagemt from "./../Assets/credit_risk_management.jpg";
import debtCollection from "./../Assets/debtCollection.jpeg";
import consumerLending from "./../Assets/Consumer-lending.png";
import comercialLending from "./../Assets/comercial-lending.jpeg";

function Analytics() {
  const [activeTab, setActiveTab] = useState("Loan Origination");

  const tabs = [
    "Loan Origination",
    "Underwriting",
    "Credit Risk Management",
    "Debt Collection",
    "Consumer Lending",
    "Commercial Lending",
  ];

  const content = {
    "Loan Origination": {
      title: "Streamlined Loan Origination",
      description:
        "Automate your loan origination process with ease. From application to approval, manage everything efficiently.",
      image: loanOrigination,
    },
    Underwriting: {
      title: "Efficient Underwriting",
      description:
        "Enhance your underwriting process with automated decision-making tools that assess risk and compliance.",
      image: Underwriting,
    },
    "Credit Risk Management": {
      title: "Comprehensive Credit Risk Management",
      description:
        "Mitigate risks with advanced credit scoring models and real-time analytics to protect your investments.",
      image: creditRisManagemt,
    },
    "Debt Collection": {
      title: "Automated Debt Collection",
      description:
        "Manage and recover outstanding debts efficiently with our automated debt collection tools.",
      image: debtCollection,
    },
    "Consumer Lending": {
      title: "Seamless Consumer Lending",
      description:
        "Provide customers with a seamless lending experience, from application to disbursement, tailored to their needs.",
      image: consumerLending,
    },
    "Commercial Lending": {
      title: "Robust Commercial Lending",
      description:
        "Support your business clients with flexible and robust commercial lending solutions.",
      image: comercialLending,
    },
  };

  return (
    <div className="bg-gradient-to-b from-black via-gray-900 to-gray-800 text-white py-12 px-4">
      <div className="max-w-[1240px] mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          ANY KIND OF LENDING PROCESS
        </h2>

        {/* Scrollable Tabs for Mobile */}
        <div className="flex overflow-x-auto no-scrollbar space-x-2 md:justify-center mb-6 px-2">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`px-4 py-2 whitespace-nowrap rounded-full font-semibold transition-all duration-200 ${
                activeTab === tab
                  ? "bg-[#00df9a] text-black"
                  : "bg-gray-700 text-white hover:bg-gray-600"
              }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Content Section */}
        <div className="flex flex-col-reverse md:flex-row items-center md:items-start gap-6">
          {/* Text Content */}
          <div className="md:w-1/2 text-center md:text-left">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              {content[activeTab].title}
            </h3>
            <p className="text-lg text-gray-300 px-2 md:px-0">
              {content[activeTab].description}
            </p>
          </div>

          {/* Image Section */}
          <div className="md:w-1/2">
            <img
              src={content[activeTab].image}
              alt={content[activeTab].title}
              className="rounded-lg shadow-lg w-full max-w-sm md:max-w-full mx-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Analytics;
